import React, {Component} from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import {Link} from 'react-router-dom';

import {LocalizedLink} from 'components/ReactRouterDomLocalized';

import {dt, t} from 'l10n';

import {commentAmateurFilm} from 'backend-helpers/amateurFilm';
import {commentWallMaterial} from 'backend-helpers/wallMaterial';
import {AMATEUR_FILM_COMMENT_SUCCESS} from 'reducers/amateurFilm';
import {WALL_MATERIAL_COMMENT_SUCCESS} from 'reducers/wallMaterial';

import {getPaymentUrl, getReturnPath} from 'utils/url';

class CommentForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            comment: '',
            sending: false
        };
        this.isWallMaterial = !!props.material.type;
        this.onSubmit = this.onSubmit.bind(this);
        this.onSubmitSuccess = this.onSubmitSuccess.bind(this);
        this.onSubmitError = this.onSubmitError.bind(this);
    }

    onSubmit() {
        let {material} = this.props;
        let {comment} = this.state;
        if (!comment) return false;

        const action = this.isWallMaterial ? commentWallMaterial : commentAmateurFilm;

        this.setState({sending: true});

        action({id: material.id, comment})
            .then(this.onSubmitSuccess)
            .catch(this.onSubmitError)
    }

    onSubmitSuccess(result) {
        let {dispatch, material} = this.props;

        const type = this.isWallMaterial ? WALL_MATERIAL_COMMENT_SUCCESS : AMATEUR_FILM_COMMENT_SUCCESS;
        dispatch({type, result, id: material.id});

        this.setState({
            comment: '',
            sending: false
        });
    }

    onSubmitError() {
        this.setState({sending: false});
    }

    render() {
        let {currentUser, location} = this.props;
        let {comment, sending} = this.state;

        if (!currentUser.isLoggedIn()) {
            return (
                <div className="ui-kit-base comments-access-restricted">
                    <p>{dt('amateur_film', 'Log in')} {dt('amateur_film', 'to post a comment')}</p>
                    <Link
                        className="login-button ui-button primary"
                        to={{
                            pathname: location.pathname,
                            search: '?login&return_path=' + encodeURIComponent(getReturnPath({hashBang: false}, location)) // send location when use ssr
                        }}
                    >{t('Log in')}</Link>
                </div>
            )
        }

        if (!currentUser.isXXL()) {
            return (
                <div className="ui-kit-base comments-access-restricted">
                    <p>{dt('amateur_film', 'You must be an XXL member')} {dt('amateur_film', 'to post a comment')}</p>
                    <LocalizedLink
                        to={getPaymentUrl(getReturnPath())}
                        className="get-xxl-button ui-button primary"
                    >
                        {dt('amateur_film', 'Become an XXL member')}
                    </LocalizedLink>
                </div>
            )
        }

        return (
            <div className="comment-create">
                <div className="avatar-comment-create">
                    <img src={currentUser.avatar_url} alt={currentUser.nick}/>
                </div>

                <div className="form-comment-create">
                        <textarea placeholder={dt('amateur_film', 'Enter your message')}
                                  value={comment}
                                  onChange={(e) => this.setState({comment: e.target.value})}
                                  readOnly={sending}
                        />
                    <div className="message-send">
                        {!sending ?
                            <button
                                className="button-message-send"
                                onClick={this.onSubmit}
                            >{t('Send')}</button>
                            :
                            <button
                                className="button-message-send loading"
                                disabled="disabled"
                            >{dt('amateur_film', 'Sending...')}</button>
                        }
                    </div>
                </div>

            </div>
        )
    }
}

let mapStateToProps = function (state) {
    return {
        currentUser: state.currentUser
    }
};

export default withRouter(connect(mapStateToProps, null)(CommentForm));


// WEBPACK FOOTER //
// ./src/components/materialPage/commentForm.js